import { TermsType } from "src/app/enums/TermsType";
import { IListOptionsFilter } from "./base";

export interface ITermsAcceptingFilter extends IListOptionsFilter {
  fiscalSetupId?: number;
  termsType?: TermsType;
  providerId?: number;
}
